import * as React from 'react';
import { SVGProps } from 'react';

const IconTreeSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3 5.5a3.5 3.5 0 1 1 4.5 3.355V10.5h6.645a3.502 3.502 0 0 1 6.855 1 3.5 3.5 0 0 1-6.855 1H7.5v4a1 1 0 0 0 1 1h5.645a3.502 3.502 0 0 1 6.855 1 3.5 3.5 0 0 1-6.855 1H8.5a3 3 0 0 1-3-3V8.855A3.502 3.502 0 0 1 3 5.5ZM17.5 13a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Zm0 7a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Z"
    />
  </svg>
);
export default IconTreeSizeM;
